import ModalCustom from './modal-custom'
export default ModalCustom



// WEBPACK FOOTER //
// ./src/views/components/modal-custom/index.js